import { render } from "./CreateCase.vue?vue&type=template&id=31684981"
import script from "./CreateCase.vue?vue&type=script&lang=js"
export * from "./CreateCase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__